import { useEffect, useState } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import DatosJerarquicos from '../../../components/tables/DatosJerarquicos'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'
import Button from '../../../components/common/Button'

const BeneficiosProyecto = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos 
    const [idTipoProyecto, setIdTipoProyecto] = useState("")
    const [idBeneficio, setIdBeneficio] = useState("")
    const [tipoProyecto, setTipoProyecto] = useState("")
    const [logoTipoProyecto, setLogoTipoProyecto] = useState("")
    const [beneficio, setBeneficio] = useState("")
    const [detalleBeneficio, setDetalleBeneficio] = useState("")
    const [actualizarBanner, setActualizarBanner] = useState(false)
    // modales
    const [mostrarModalRegistrarTipoProyecto, setMostrarModalRegistrarTipoProyecto] = useState(false)
    const [mostrarModalRegistrarBeneficio, setMostrarModalRegistrarBeneficio] = useState(false)
    const [mostrarModalEditarBeneficio, setMostrarModalEditarBeneficio] = useState(false)
    const [mostrarModalEditarLogo, setMostrarModalEditarLogo] = useState(false)
    const [mostrarModalConfirmacion, setMostrarModalConfirmacion] = useState(false)
    const [mostrarModalConfirmacionDetalle, setMostrarModalConfirmacionDetalle] = useState(false)
    // notificaciones y cargas 
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)

    // Carga inicial de los tipos de proyectos con sus beneficios
    useEffect(() => { obtenerBeneficiosProyecto() }, [])

    // Función para traer los tipos de proyectos con sus beneficios
    const obtenerBeneficiosProyecto = async () => {
        const respuesta = await consumirApi('GET', `maestros/beneficio-proyecto/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    // Registro de un nuevo tipo de proyecto
    const registrarTipoProyecto = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', 'maestros/tipo-proyecto', formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Tipo de proyecto registrado correctamente" })
            limpiarCampos()
            obtenerBeneficiosProyecto()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Apertura del modal para editar un beneficio
    const abrirModalEditarLogo = (data) => {
        setIdTipoProyecto(data.id)
        setTipoProyecto(data.descripcion)
        setMostrarModalEditarLogo(true)
    }

    const actualizarTipoProyecto = async (e) => {
        e.preventDefault()

        const formData = new FormData(e.target) // Capturamos los datos del formulario
        setIsSubmitting(true)

        // Solo agregar el logo si el checkbox "Actualizar banner" está marcado
        if (!actualizarBanner) {
            formData.delete("logo_tipo_proyecto") // Eliminamos el campo si no es necesario
        }

        const respuesta = await consumirApi('POST', 'maestros/tipo-proyecto/editar', formData)

        if (respuesta.success) {
            setNotificacion({
                estado: true,
                tipo: "actualizacion",
                mensaje: `Tipo de proyecto actualizado correctamente`,
            })
            obtenerBeneficiosProyecto() // Actualizar datos visibles en la interfaz
            limpiarCampos() // Resetear los estados y cerrar modal
        } else {
            setError(respuesta.error)
            setIsSubmitting(false) // Restaurar el botón si hay error
        }
    }


    // Apertura del modal para registrar un nuevo beneficio
    const abrirModalRegistroBeneficio = (tipoProyecto) => {
        setIdTipoProyecto(tipoProyecto)
        setMostrarModalRegistrarBeneficio(true)
    }

    // Registro de un nuevo beneficio
    const registrarBeneficio = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', 'maestros/beneficio-proyecto', formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Beneficio registrado correctamente" })
            limpiarCampos()
            obtenerBeneficiosProyecto()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Apertura del modal para editar un beneficio
    const abrirModalEditar = (data) => {
        setIdBeneficio(data.id)
        setBeneficio(data.nombre)
        setDetalleBeneficio(data.detalle)
        setMostrarModalEditarBeneficio(true)
    }

    // Edición de un beneficio
    const enviarEdicionBeneficio = async (e) => {
        e.preventDefault()
        const data = { beneficio, detalle_beneficio: detalleBeneficio }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/beneficio-proyecto/${idBeneficio}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Beneficio actualizado correctamente" })
            limpiarCampos()
            obtenerBeneficiosProyecto()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Apertura del modal de confirmación para eliminar un tipo de proyecto
    const abrirModalEliminar = (id) => {
        setIdTipoProyecto(id)
        setMostrarModalConfirmacion(true)
    }

    // Eliminación de un tipo de proyecto
    const eliminarTipoProyecto = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/tipo-proyecto/${idTipoProyecto}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Tipo de proyecto eliminado correctamente" })
            setMostrarModalConfirmacion(false)
            obtenerBeneficiosProyecto()
        } else {
            setError(respuesta.error)
        }
    }

    // Apertura del modal de confirmación para eliminar un beneficio
    const abrirModalEliminarDetalle = (id) => {
        setIdBeneficio(id)
        setMostrarModalConfirmacionDetalle(true)
    }

    // Eliminación de un beneficio
    const eliminarBeneficio = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/beneficio-proyecto/${idBeneficio}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Beneficio eliminado correctamente" })
            setMostrarModalConfirmacionDetalle(false)
            obtenerBeneficiosProyecto()
        } else {
            setError(respuesta.error)
        }
    }

    // Limpieza de campos y cierre de modales
    const limpiarCampos = () => {
        setMostrarModalRegistrarTipoProyecto(false)
        setMostrarModalRegistrarBeneficio(false)
        setMostrarModalEditarBeneficio(false)
        setMostrarModalEditarLogo(false)
        setMostrarModalConfirmacion(false)
        setMostrarModalConfirmacionDetalle(false)
        setTipoProyecto('')
        setBeneficio('')
        setDetalleBeneficio('')
        setError('')

        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModalRegistrarTipoProyecto(true)} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron tipos de proyectos</div>
                ) : (
                    <div className="max-h-content overflow-y-auto">
                        <DatosJerarquicos
                            data={datos}
                            eliminar={abrirModalEliminar}
                            eliminarDetalle={abrirModalEliminarDetalle}
                            editar={abrirModalEditar}
                            editarPadre={abrirModalEditarLogo}
                            registrar={abrirModalRegistroBeneficio}
                            campoTitulo="tipo_proyecto"
                            campoDetalles="beneficios"
                            campoNombre="beneficio"
                            campoDetalle="detalle_beneficio"
                            nombreTitulo='Beneficio'
                            nombreDetalle='Detalle beneficio'
                        />
                    </div>
                )
            )}

            {/* Modales */}
            <Modal isOpen={mostrarModalRegistrarTipoProyecto} title="Registrar nuevo Tipo de proyecto" onClose={limpiarCampos}>
                <Form onSubmit={registrarTipoProyecto} isSubmitting={isSubmitting}>
                    <Input name="tipo_proyecto" value={tipoProyecto} label="Tipo de proyecto" onChange={setTipoProyecto} />
                    <Input name="logo_tipo_proyecto" label="Banner tipo proyecto" type="file" onChange={setLogoTipoProyecto} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal para registrar un nuevo beneficio */}
            <Modal isOpen={mostrarModalRegistrarBeneficio} title="Registrar nuevo beneficio" onClose={limpiarCampos}>
                <Form onSubmit={registrarBeneficio} isSubmitting={isSubmitting}>
                    <Input name="tipo_proyecto_id" value={idTipoProyecto} show='hidden' />
                    <Input name="beneficio" value={beneficio} label="Beneficio" onChange={setBeneficio} />
                    <Input
                        name="detalle_beneficio"
                        value={detalleBeneficio}
                        label="Detalle del beneficio"
                        onChange={setDetalleBeneficio}
                        type="textarea"
                    />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal para editar un beneficio */}
            <Modal isOpen={mostrarModalEditarBeneficio} title="Editar beneficio" onClose={limpiarCampos}>
                <Form onSubmit={enviarEdicionBeneficio} type="update" isSubmitting={isSubmitting} >
                    <Input name="beneficio" value={beneficio} label="Beneficio" onChange={setBeneficio} />
                    <Input
                        name="detalle_beneficio"
                        value={detalleBeneficio}
                        label="Detalle del beneficio"
                        onChange={setDetalleBeneficio}
                        type="textarea"
                    />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modales para editar logo del tipo de proyecto */}
            <Modal isOpen={mostrarModalEditarLogo} title="Editar tipo de proyecto" onClose={limpiarCampos}>
                <Form onSubmit={actualizarTipoProyecto} type="update"  isSubmitting={isSubmitting}>
                    {/* Campo para editar el nombre del tipo de proyecto */}
                    <Input name="id" value={idTipoProyecto} show='hidden' />
                    <Input
                        name="tipo_proyecto"
                        label="Nombre del tipo de proyecto"
                        value={tipoProyecto}
                        onChange={(value) => setTipoProyecto(value)}
                    />

                    {/* Checkbox para mostrar/ocultar el campo de actualización de imagen */}
                    <div className="flex items-center gap-2 my-4">
                        <input
                            type="checkbox"
                            id="actualizarBanner"
                            checked={actualizarBanner}
                            onChange={(e) => setActualizarBanner(e.target.checked)}
                        />
                        <label htmlFor="actualizarBanner">Actualizar banner</label>
                    </div>

                    {/* Campo de archivo condicional */}
                    {actualizarBanner && (
                        <Input
                            name="logo_tipo_proyecto"
                            label="Banner tipo proyecto"
                            type="file"
                            onChange={setLogoTipoProyecto}
                        />
                    )}

                    {/* Mostrar errores, si los hay */}
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>


            {/* Modal de confirmación para eliminar un tipo de proyecto*/}
            <ModalConfirmacion
                isOpen={mostrarModalConfirmacion}
                onClose={limpiarCampos}
                onConfirm={eliminarTipoProyecto}
                mensaje="¿Estás seguro de que deseas eliminar el tipo de proyecto?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>

            {/* Modal de confirmación para eliminar un beneficio */}
            <ModalConfirmacion
                isOpen={mostrarModalConfirmacionDetalle}
                onClose={() => setMostrarModalConfirmacionDetalle(false)}
                onConfirm={eliminarBeneficio}
                mensaje="¿Estás seguro de que deseas eliminar este beneficio?"
            />
        </div>
    )
}

export default BeneficiosProyecto